import { render } from "./Lottery_setting.vue?vue&type=template&id=df97d138"
import script from "./Lottery_setting.vue?vue&type=script&lang=js"
export * from "./Lottery_setting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__